/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AllFeatureFlags {
    getFixupPrototypeFunction() { return AllFeatureFlags.fixupPrototype; }

    static newInstance(model: Partial<AllFeatureFlags>): AllFeatureFlags {
        let obj = Object.assign(new AllFeatureFlags(), model);
        AllFeatureFlags.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AllFeatureFlags>): AllFeatureFlags {
        if (!model) return null;
        return AllFeatureFlags.newInstance(<AllFeatureFlags> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AllFeatureFlags) {
        if (!obj) return;

        models.AllFeatureFlags.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AllFeatureFlags): boolean {
        Object.setPrototypeOf(obj, AllFeatureFlags.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Release Feature Flags
     */
    release_flags: models.ReleaseFlags;

    /**
     * AI Feature Flags
     */
    ai_feature_flags: models.AIFeatureFlags;

    /**
     * AI Agent Feature Flags
     */
    ai_agent_feature_flags: models.AIAgentFeatureFlags;

    /**
     * Broker Feature Flags
     */
    broker_feature_flags: models.BrokerFeatureFlags;

    /**
     * Compliance Feature Flags
     */
    compliance_feature_flags: models.ComplianceFeatureFlags;

    /**
     * Cost Feature Flags
     */
    cost_feature_flags: models.CostFeatureFlags;

    /**
     * Governance Feature Flags
     */
    governance_feature_flags: models.GovernanceFeatureFlags;

    /**
     * Heatstack Feature Flags
     */
    heatstack_feature_flags: models.HeatstackFeatureFlags;

    /**
     * Identity Feature Flags
     */
    identity_feature_flags: models.IdentityFeatureFlags;

    /**
     * Operations Governance Feature Flags
     */
    operations_governance_feature_flags: models.OperationsGovernanceFeatureFlags;

    /**
     * Others Feature Flags
     */
    others_feature_flags: models.OthersFeatureFlags;

    /**
     * Report Generation Feature Flags
     */
    report_generation_feature_flags: models.ReportGenerationFeatureFlags;

    /**
     * Report Generation Feature Flags
     */
    reports_feature_flags: models.ReportsFeatureFlags;

    /**
     * Resource Inventory Feature Flags
     */
    resource_inventory_feature_flags: models.ResourceInventoryFeatureFlags;

    /**
     * Security Governance Feature Flags
     */
    security_governance_feature_flags: models.SecurityGovernanceFeatureFlags;

    /**
     * Ui Feature Flags
     */
    ui_feature_flags: models.UiFeatureFlags;

}
